module.exports = __webpack_public_path__ + "img/travelmap.72eebbd1.png";